import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";

export default function Men({ data }) {
  const { addToCart } = useContext(CartContext);

  return (
    <div className="flex flex-wrap justify-center gap-8 p-6">
      {data.map((item) => (
        <div
          key={item.id}
          className="
            w-64 bg-white rounded-2xl overflow-hidden
            shadow-md transition-all duration-300 ease-in-out
            hover:shadow-2xl hover:-translate-y-3 hover:scale-105
          "
        >
          <div className="h-60 w-full bg-gray-100 flex items-center justify-center overflow-hidden">
            <img
              src={item.img}
              alt={item.name}
              className="
                max-h-full max-w-full object-contain
                transition-transform duration-300
                hover:scale-110
              "
            />
          </div>

          <div className="p-5">
            <h2 className="text-lg font-semibold text-gray-800">{item.name}</h2>
            <p className="text-gray-600 mt-2 font-medium">₹ {item.price}</p>

            <button
              onClick={() => addToCart(item)}
              className="
                mt-4 w-full bg-blue-600 text-white py-2 rounded-lg
                transition-all duration-300
                hover:bg-blue-700 hover:scale-105
                active:scale-95
              "
            >
              Add to Cart
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}